/**
 * Created by mzietek on 2017-03-14.
 */

(function(){

    angular
        .module('repairforms.directive.module')
        .directive('validateDate', validateDate);

    validateDate.$inject = ['FormInputPossibleErrors', 'DateService'];


    function validateDate (FormInputPossibleErrors, DateService) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {

                var holidayList     = attrs.holidayList;
                var pickUpTimeLimit = attrs.pickUpHourLimit;
                var datePattern     = attrs.datePattern;
                var pickUpHourLimit = pickUpTimeLimit.split(":")[0];
                var pickUpMinutesLimit = (pickUpMinutesLimit && pickUpTimeLimit.includes(":")) ? pickUpMinutesLimit.split(":")[1] : 0;

                var errors = FormInputPossibleErrors.getPossibleErrors();
                var dateRegExp = new RegExp(datePattern);

                ctrl.$validators[errors.DATEINVALID] = checkIfDateValid;
                ctrl.$validators[errors.PATTERN]     = checkIfPatternValid;
                ctrl.$validators[errors.WRONGDATE]   = checkIfWrongDate;


                function checkIfDateValid(value) {
                    if(attrs.required) {
                        var date = DateService.dsplDateToDateObj(value);
                        return DateService.isValidDate(date);
                    }

                    return true;
                };

                function checkIfPatternValid(value) {
                    if(attrs.required) {
                        return dateRegExp.test(value);
                    }

                    return true;
                };

                function checkIfWrongDate(value) {
                    if(attrs.required) {
                        var isDateValid = checkIfDateValid(value);
                        var dateMatchesPattern = checkIfPatternValid(value);
                        if (isDateValid && dateMatchesPattern) {
                            var date = DateService.dsplDateToDateObj(value);
                            var isDateHoliday = holidayList ? DateService.isHoliday(date, holidayList) : false;
                            var isWorkingDay = DateService.isWorkingDay(date) && !isDateHoliday;
                            var isAcceptableDay = pickUpHourLimit ? (isWorkingDay && DateService.isAcceptablePickUpDay(date, pickUpHourLimit, pickUpMinutesLimit)) : isWorkingDay;
                            return isAcceptableDay;
                        }

                        return false;
                    }

                    return true;
                };
            }
        };
    }

})();